import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Observable, BehaviorSubject, Subject } from 'rxjs';
import {
  EmailEventService,
  EmailEvent,
  EmailMessage,
  EventType,
  PagedRequestOptions,
  ListEmailEventsResponse,
} from '@vendasta/email';
import { SiteService } from '../../../core/site';
import { switchMap, takeUntil } from 'rxjs/operators';

@Component({
  selector: 'app-smb-email-preview',
  templateUrl: './smb-email-preview.component.html',
  styleUrls: ['./smb-email-preview.component.scss'],
  standalone: false,
})
export class SmbEmailPreviewDialogComponent implements OnInit, OnDestroy {
  email: EmailMessage;
  events$: Observable<EmailEvent[]>;
  private _events$$: BehaviorSubject<EmailEvent[]> = new BehaviorSubject<EmailEvent[]>([]);

  // Initial tab to open
  selectedTab: any = 1;
  private ngUnsubscribe = new Subject<void>();

  constructor(
    private _eventService: EmailEventService,
    private _siteService: SiteService,
    public dialogRef: MatDialogRef<SmbEmailPreviewDialogComponent>,
    @Inject(MAT_DIALOG_DATA) private _email: EmailMessage,
  ) {
    this.email = _email;
  }

  ngOnInit(): void {
    const po = new PagedRequestOptions({ cursor: '', pageSize: 10 });
    this.activeTab();
    this.events$ = this._events$$.asObservable();
    this._siteService.site$
      .pipe(
        switchMap((site) => this._eventService.listEvents(this.email.emailId, po, site.partnerId, site.accountId)),
        takeUntil(this.ngUnsubscribe),
      )
      .subscribe((res: ListEmailEventsResponse) => {
        this._events$$.next(res.events);
      });
  }

  /**
   * Returns the HTML content representation of the email
   * @return string HTML email content
   */
  get htmlContent(): string {
    const filtered = this.email.content.filter((c) => c.type === 1);
    return filtered.length > 0 ? filtered[0].value : this.email.content[0].value;
  }

  /**
   * Changes the width of the smb-email-preview window/dialog
   * @param newWidth - string representation of the number of pixels to use as the width
   */
  changePreviewWidth(newWidth: string): void {
    const preview = document.getElementById('email-preview-iframe');
    preview.style.width = newWidth;

    // hide sourceCode if visible
    const sourceCode = document.getElementById('source-code');
    if (sourceCode.style.display === 'block') {
      sourceCode.style.display = 'none';
    }
  }

  toggleSourceCode(): void {
    const sourceCode = document.getElementById('source-code');
    if (sourceCode.style.display === 'block') {
      sourceCode.style.display = 'none';
    } else {
      sourceCode.style.display = 'block';
    }
  }

  activeTab(currentTab?: any): void {
    const storedTab = sessionStorage.getItem('storedTab');

    if (currentTab) {
      // if a new tab is passed in, then update the saved value in sessionStorage
      sessionStorage.setItem('storedTab', currentTab.index);
    } else if (storedTab) {
      // if no new tab is passed in, the set the current tab to what is saved in sessionStorage
      this.selectedTab = storedTab;
    }
  }

  eventTypeToString(e: EventType): string {
    return EventType[e];
  }

  ngOnDestroy(): void {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }
}
